import { jsonToUrlParams, trimObjectValues } from '@/utils';

import { omit } from 'ramda';

import api, {
	GetSystemUserListParams,
	GetSystemUseTipListParams,
	GetSystemUseTipListResponse,
	TCreateFooterInfoRequestParams,
	TCreateForeignSystemUnitRequest,
	TCreateSystemUnitRequest,
	TCreateSystemUserRequest,
	TCreateSystemUseTipRequest,
	TGetFooterInfoListParams,
	TGetHistoryUpdateSystemUnitListParams,
	TGetListContractedKoreanBusinessParams,
	TGetListForeignSystemUnitParams,
	TGetListSystemUnitParams,
} from '.';

export const getSystemUserList = async ({
	page,
	pageSize,
	sortSql = '',
	...rest
}: GetSystemUserListParams) =>
	await api.post(
		`/system/user/list?${jsonToUrlParams({ page, pageSize, sortSql })}`,
		rest
	);

export const getSystemUserDetail = async (id: number) =>
	await api.get(`/system/user/detail?userId=${id}`);

export const deleteSystemUser = async (ids: number[]) =>
	await api.post('/system/user/delete', ids);

export const createSystemUser = async (data: TCreateSystemUserRequest) =>
	await api.post('/system/user/create', trimObjectValues(data));

/* ---- SYSTEM UNIT START---- */
export const getSystemUnitList = async ({
	page,
	pageSize,
	sortSql = '',
	...rest
}: TGetListSystemUnitParams) =>
	await api.post(
		`/system/unit/list?${jsonToUrlParams({ page, pageSize, sortSql })}`,
		rest
	);

export const deleteSystemUnit = async (ids: number[]) =>
	await api.post('/system/unit/delete', ids);

export const createSystemUnit = async (data: TCreateSystemUnitRequest) =>
	await api.post('/system/unit/create', trimObjectValues(data));

export const getSystemUnitDetail = async (id: string) =>
	await api.get(`/system/unit/detail?id=${id}`);

export const getHistoryUpdateSystemUnitList = async (
	params: TGetHistoryUpdateSystemUnitListParams
) =>
	await api.post(
		`/system/unit/updateHistory?${jsonToUrlParams({ ...params })}`
	);

/* ---- SYSTEM UNIT END---- */

/* ---- FOOTER INFO START---- */
export const getFooterInfoList = async (params: TGetFooterInfoListParams) => {
	const { isSystemAdmin, unitId } = params;
	if (isSystemAdmin) {
		return await api.get(`/system/unit/${unitId}/webInfo`);
	} else {
		return await api.get('/worker/unit/webInfo/list');
	}
};

export const createFooterInfo = async (data: TCreateFooterInfoRequestParams) =>
	await api.post('/worker/unit/webInfo/create', trimObjectValues(data));

/* ---- FOOTER INFO END---- */

/* ---- FOREIGN SYSTEM UNIT START---- */
export const getForeignSystemUnitList = async ({
	page,
	pageSize,
	sortSql = '',
	...rest
}: TGetListForeignSystemUnitParams) =>
	await api.post(
		`/system/unit/foreign/list?${jsonToUrlParams({ page, pageSize, sortSql })}`,
		rest
	);

export const createForeignSystemUnit = async (
	data: TCreateForeignSystemUnitRequest
) => await api.post('/system/unit/foreign/create', trimObjectValues(data));

export const getForeignSystemUnitDetail = async (id: string) =>
	await api.get(`/system/unit/foreign/${id}/detail`);

export const getForeignHistoryUpdateSystemUnitList = async (
	params: TGetHistoryUpdateSystemUnitListParams
) =>
	await api.post(
		`/system/unit/foreign/updateHistory?${jsonToUrlParams({ ...params })}`
	);
export const getContractedKoreanBusinessSystem = async (
	params: TGetListContractedKoreanBusinessParams
) => {
	const { id, page, pageSize, allData = false } = params;
	return await api.get(
		`/system/unit/foreign/${id}/contract/list?${jsonToUrlParams({ page, pageSize, allData })}`
	);
};

export const deleteForeignSystemUnit = async (ids: number[]) =>
	await api.post('/system/unit/foreign/delete', ids);

/* ---- FOREIGN SYSTEM UNIT END---- */
export const getSystemUseTipList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetSystemUseTipListParams) => {
	return await api.post<GetSystemUseTipListResponse>(
		`/system/useTip/list?${jsonToUrlParams({ page, pageSize, allData, sortSql })}`,
		rest
	);
};

export const getSystemUseTipDetail = async (id: number) => {
	return await api.get(`/system/useTip/${id}/detail`);
};

export const createSystemUseTip = async (data: TCreateSystemUseTipRequest) =>
	await api.post('/system/useTip/create', {
		...data,
		...trimObjectValues(omit(['content'], data)),
	});

export const deleteSystemUseTip = async (ids: number[]) =>
	await api.post('/system/useTip/delete', ids);
